import React, { useContext, useState } from "react";
import {
  ComplaintInterface,
  ShowComplaintsContext,
} from "./types";
import ButtonsForm from "../../HtmlComponents/ButtonsForm";
import { useDispatch } from "react-redux";
import { DeleteComplaintApi } from "../../redux/complaints/complaintApiCalls";
import { Timeout } from "../../functions/functions";
import ShowErrorMsg from "../../HtmlComponents/ShowErrorMsg";

interface DeleteComplaintInterface {
  modal: boolean;
  toggle: () => void;
  ComplaintData: ComplaintInterface;
}

const DeleteComplaint: React.FC<DeleteComplaintInterface> = ({
  modal,
  toggle,
  ComplaintData,
}) => {
  const [errors, setErrors] = useState<string[]>([]);

  const { setShowSuccessMsg } = useContext(
    ShowComplaintsContext
  );
  const dispatch: any = useDispatch();
  const [loading, setLoading] = useState(false)

  const handleSubmit = async (e: any) => {
    e.preventDefault();
    setLoading(true)
    try {
      const response: any = await dispatch(
        DeleteComplaintApi(ComplaintData._id)
      );
      if (response === true) {
        setShowSuccessMsg(true);
        toggle();
        setTimeout(() => setShowSuccessMsg(false), Timeout);
      } else {
        setErrors(response);
      }
    } finally {
      setLoading(false)
    }
  };

  return (
    <div>
      {modal && (
        <>
          <div className="fixed inset-0 z-10 overflow-y-auto">
            <div
              className="fixed inset-0 w-full h-full bg-black opacity-40"
              onClick={toggle}
            ></div>
            <div className="flex items-center min-h-screen px-4 py-8">
              <div className="relative w-full max-w-lg p-4 mx-auto bg-white rounded-md shadow-lg">
                <div className="mt-3">
                  {/* Start Modal Body */}
                  <form
                    className="mt-2 sm:ml-4 sm:text-left"
                    onSubmit={handleSubmit}
                  >
                    <ShowErrorMsg errors={errors} setErrors={setErrors} />
                    <ButtonsForm loading={loading} toggle={toggle} typeBtn="Supprimer" />
                  </form>
                  {/* End Modal Body */}
                </div>
              </div>
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default DeleteComplaint;
